import { IItemLookup } from '../common/interfaces/dtos/IItemLookup';
import { ITareWeightGroup } from '../common/interfaces/states/ITareWeightGroupsState';
import { store } from '../common/redux/configure-store';
import { TareWeightGroupsActions } from '../common/redux/reducers/tare-weight-groups-reducer';

export const addTareWeightGroup = (
  itemId: string,
  linkedItems: IItemLookup[],
  isManualTarePercentageEnabled?: boolean,
): void => {
  store.dispatch(
    TareWeightGroupsActions.addTareWeightGroup(itemId, linkedItems, isManualTarePercentageEnabled),
  );
};

export const getTareWeightGroup = (itemId: string): ITareWeightGroup | undefined => {
  const tareWeightGroups = store.getState().tareWeightGroups;
  return tareWeightGroups[itemId];
};
